/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPremiumDueBodyDto
 */
export interface GetPremiumDueBodyDto {
    /**
     * Page number (1-based)
     * @type {number}
     * @memberof GetPremiumDueBodyDto
     */
    page?: number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof GetPremiumDueBodyDto
     */
    pageSize?: number;
    /**
     * Filter by broker IDs
     * @type {Array<string>}
     * @memberof GetPremiumDueBodyDto
     */
    brokerIds?: Array<string>;
    /**
     * Filter by reinsured IDs
     * @type {Array<string>}
     * @memberof GetPremiumDueBodyDto
     */
    reinsuredIds?: Array<string>;
    /**
     * Filter by insured IDs
     * @type {Array<string>}
     * @memberof GetPremiumDueBodyDto
     */
    insuredIds?: Array<string>;
    /**
     * Filter by binder IDs
     * @type {Array<string>}
     * @memberof GetPremiumDueBodyDto
     */
    binderIds?: Array<string>;
    /**
     * Filter by premium status
     * @type {Array<string>}
     * @memberof GetPremiumDueBodyDto
     */
    premiumStatus?: Array<GetPremiumDueBodyDtoPremiumStatusEnum>;
    /**
     * Filter by PPW due date from (YYYY-MM-DD)
     * @type {Date}
     * @memberof GetPremiumDueBodyDto
     */
    ppwDueDateFrom?: Date;
    /**
     * Filter by PPW due date to (YYYY-MM-DD)
     * @type {Date}
     * @memberof GetPremiumDueBodyDto
     */
    ppwDueDateTo?: Date;
    /**
     * Filter by inception date from (YYYY-MM-DD)
     * @type {Date}
     * @memberof GetPremiumDueBodyDto
     */
    inceptionDateFrom?: Date;
    /**
     * Filter by inception date to (YYYY-MM-DD)
     * @type {Date}
     * @memberof GetPremiumDueBodyDto
     */
    inceptionDateTo?: Date;
    /**
     * Filter by expiry date from (YYYY-MM-DD)
     * @type {Date}
     * @memberof GetPremiumDueBodyDto
     */
    expiryDateFrom?: Date;
    /**
     * Filter by expiry date to (YYYY-MM-DD)
     * @type {Date}
     * @memberof GetPremiumDueBodyDto
     */
    expiryDateTo?: Date;
    /**
     * Filter by closing status
     * @type {boolean}
     * @memberof GetPremiumDueBodyDto
     */
    closing?: boolean;
    /**
     * Filter by payment status
     * @type {boolean}
     * @memberof GetPremiumDueBodyDto
     */
    isPaid?: boolean;
    /**
     * Sort field
     * @type {string}
     * @memberof GetPremiumDueBodyDto
     */
    sortField?: GetPremiumDueBodyDtoSortFieldEnum;
    /**
     * Sort order
     * @type {string}
     * @memberof GetPremiumDueBodyDto
     */
    sortOrder?: GetPremiumDueBodyDtoSortOrderEnum;
}


/**
 * @export
 */
export const GetPremiumDueBodyDtoPremiumStatusEnum = {
    Current: 'Current',
    Overdue30Days: 'overdue_30_days',
    Overdue60Days: 'overdue_60_days',
    Overdue90Days: 'overdue_90_days',
    OverdueMoreThan90Days: 'overdue_more_than_90_days',
    Paid: 'Paid'
} as const;
export type GetPremiumDueBodyDtoPremiumStatusEnum = typeof GetPremiumDueBodyDtoPremiumStatusEnum[keyof typeof GetPremiumDueBodyDtoPremiumStatusEnum];

/**
 * @export
 */
export const GetPremiumDueBodyDtoSortFieldEnum = {
    Broker: 'broker',
    Reinsured: 'reinsured',
    Insured: 'insured',
    PremiumStatus: 'premiumStatus',
    PpwDueDate: 'ppwDueDate',
    Binder: 'binder',
    InceptionDate: 'inceptionDate',
    ExpiryDate: 'expiryDate'
} as const;
export type GetPremiumDueBodyDtoSortFieldEnum = typeof GetPremiumDueBodyDtoSortFieldEnum[keyof typeof GetPremiumDueBodyDtoSortFieldEnum];

/**
 * @export
 */
export const GetPremiumDueBodyDtoSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetPremiumDueBodyDtoSortOrderEnum = typeof GetPremiumDueBodyDtoSortOrderEnum[keyof typeof GetPremiumDueBodyDtoSortOrderEnum];


/**
 * Check if a given object implements the GetPremiumDueBodyDto interface.
 */
export function instanceOfGetPremiumDueBodyDto(value: object): value is GetPremiumDueBodyDto {
    return true;
}

export function GetPremiumDueBodyDtoFromJSON(json: any): GetPremiumDueBodyDto {
    return GetPremiumDueBodyDtoFromJSONTyped(json, false);
}

export function GetPremiumDueBodyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPremiumDueBodyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'brokerIds': json['brokerIds'] == null ? undefined : json['brokerIds'],
        'reinsuredIds': json['reinsuredIds'] == null ? undefined : json['reinsuredIds'],
        'insuredIds': json['insuredIds'] == null ? undefined : json['insuredIds'],
        'binderIds': json['binderIds'] == null ? undefined : json['binderIds'],
        'premiumStatus': json['premiumStatus'] == null ? undefined : json['premiumStatus'],
        'ppwDueDateFrom': json['ppwDueDateFrom'] == null ? undefined : (new Date(json['ppwDueDateFrom'])),
        'ppwDueDateTo': json['ppwDueDateTo'] == null ? undefined : (new Date(json['ppwDueDateTo'])),
        'inceptionDateFrom': json['inceptionDateFrom'] == null ? undefined : (new Date(json['inceptionDateFrom'])),
        'inceptionDateTo': json['inceptionDateTo'] == null ? undefined : (new Date(json['inceptionDateTo'])),
        'expiryDateFrom': json['expiryDateFrom'] == null ? undefined : (new Date(json['expiryDateFrom'])),
        'expiryDateTo': json['expiryDateTo'] == null ? undefined : (new Date(json['expiryDateTo'])),
        'closing': json['closing'] == null ? undefined : json['closing'],
        'isPaid': json['isPaid'] == null ? undefined : json['isPaid'],
        'sortField': json['sortField'] == null ? undefined : json['sortField'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    };
}

export function GetPremiumDueBodyDtoToJSON(json: any): GetPremiumDueBodyDto {
    return GetPremiumDueBodyDtoToJSONTyped(json, false);
}

export function GetPremiumDueBodyDtoToJSONTyped(value?: GetPremiumDueBodyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'pageSize': value['pageSize'],
        'brokerIds': value['brokerIds'],
        'reinsuredIds': value['reinsuredIds'],
        'insuredIds': value['insuredIds'],
        'binderIds': value['binderIds'],
        'premiumStatus': value['premiumStatus'],
        'ppwDueDateFrom': value['ppwDueDateFrom'] == null ? undefined : ((value['ppwDueDateFrom']).toISOString()),
        'ppwDueDateTo': value['ppwDueDateTo'] == null ? undefined : ((value['ppwDueDateTo']).toISOString()),
        'inceptionDateFrom': value['inceptionDateFrom'] == null ? undefined : ((value['inceptionDateFrom']).toISOString()),
        'inceptionDateTo': value['inceptionDateTo'] == null ? undefined : ((value['inceptionDateTo']).toISOString()),
        'expiryDateFrom': value['expiryDateFrom'] == null ? undefined : ((value['expiryDateFrom']).toISOString()),
        'expiryDateTo': value['expiryDateTo'] == null ? undefined : ((value['expiryDateTo']).toISOString()),
        'closing': value['closing'],
        'isPaid': value['isPaid'],
        'sortField': value['sortField'],
        'sortOrder': value['sortOrder'],
    };
}

